import { ACCOUNT_DISPOSITION_STATUSES } from "shared/lib/constants/account";

export const ACCOUNTS_DETAILS_TABS = {
  DIALER_TOOLKIT: "dialer_toolkit",
  DETAILS: "details",
  HISTORY: "history",
  AE_MESSAGES: "ae_messages",
  SCRIPTS: "scripts",
} as const;

export const ACCOUNT_SIDEBAR_ACTION_BUTTON_CLASSNAME =
  "ae-link typography-body-4 flex items-center gap-2";

export const ACCOUNT_STATUSES_PROTECTED_FROM_DELETE = [
  ACCOUNT_DISPOSITION_STATUSES.MEETING_SCHEDULED,
  ACCOUNT_DISPOSITION_STATUSES.NURTURE,
];
